module.exports = __webpack_public_path__ + "static/22-caef992802302f7d219074340d7d6597.png";